















import { Component, Prop, Vue } from "vue-property-decorator";
import CzIcon from "./CzIcon.vue";

@Component({ components: { CzIcon } })
export default class CzAccordion extends Vue {
  @Prop({ type: Boolean, default: false }) open!: boolean;
}
